
$(window).on('load', function(){
    if (window.matchMedia( '(max-width: 768px)' ).matches) {
        var craft_slide = new Swiper ('.craft_slide', {
            autoHeight: true,
            speed:1500,
            loop: true,
            autoplay: {
                delay: 2000,
            },
            slideToClickedSlide: true,
            slidesPerView: 2.2,
            spaceBetween:5,
            navigation: {
                nextEl: '.swiper-button-next01',
                prevEl: '.swiper-button-prev01',
            }
        });
    } else {
        var craft_slide = new Swiper ('.craft_slide', {
            autoHeight: true,
            speed:1500,
            loop: true,
            autoplay: {
                delay: 2000,
            },
            slideToClickedSlide: true,
            slidesPerView: 2.5,
            spaceBetween:8,
            navigation: {
                nextEl: '.swiper-button-next01',
                prevEl: '.swiper-button-prev01',
            }
        });
    };

});
